export default __webpack_public_path__ + "static/media/capture-feedback.c92ed493.svg";